import "devextreme/dist/css/dx.light.css";

import { Controller, useForm } from "react-hook-form";
import NumberEditor from "../components/Global/Editors/NumberEditor";
import FormattedNumberEditor from "../components/Global/Editors/FormattedNumberEditor";
import { Button } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import { MapTooltip } from "../types/globalData";
import { nameof } from "../components/Global/Utils";
import { logDebugSilently } from "../modules/logger";

const Test = () => {
  const formHook = useForm({
    defaultValues: { aPercentage: 20, aBigNumber: 123456789 } as any,
  });

  const {
    handleSubmit,
    formState: { errors, isDirty },
    control,
  } = formHook;

  const intOnSubmit = (data: any) => {
    logDebugSilently(data);
  };

  return (
    <div>
      <div>
        {/* <h1>TEST</h1>
        <form onSubmit={handleSubmit(intOnSubmit)} className="ModuleConfiguratorForm">
          <div className="row ml-0">
            <div className="col-lg-4">
              <NumberEditor label="Normal" fieldName="aProcent" formHook={formHook}></NumberEditor>
            </div>
            <div className="col-lg-4">
              <FormattedNumberEditor label="Procent:" fieldName="aProcent" formHook={formHook} formatOptions={{ suffix: " %" }}></FormattedNumberEditor>
            </div>
            <div className="col-lg-4">
              <Controller
                control={control}
                name={"fieldName"}
                rules={{ ...{} }}
                render={({ field }) => (
                  <NumericFormat
                    //className={"form-control "}
                    thousandSeparator={true}
                    suffix=" %"
                    displayType="input"
                    type="text"
                    // onValueChange={(values) => onChange(values.floatValue)}
                    className={`form-control ${errors[field.name] ? "is-invalid" : ""}`}
                    // name={name}
                    // value={value}
                    // onBlur={onBlur}
                    //ref={ref}
                    {...field}
                    onValueChange={(values) => {
                      field.onChange(values.floatValue ?? null);
                    }}
                  />
                )}
              />
            </div>
          </div>
          <div className="row ml-0">
            <div className="col-lg-4">
              <NumberEditor label="Big number" fieldName="aBigNumber" formHook={formHook}></NumberEditor>
            </div>
            <div className="col-lg-4">
              <FormattedNumberEditor label="Big number" fieldName="aBigNumber" formHook={formHook} formatOptions={{ thousandSeparator: " " }}></FormattedNumberEditor>
            </div>
          </div>
          <div className="row ml-0">
            <div className="col-lg-8"></div>
            <div className="col-lg-4">
              <Button type="submit">Submit</Button>
            </div>
          </div>
        </form>
        <div></div>
        <hr /> */}
        <h1>TEST</h1>
        <form onSubmit={handleSubmit(intOnSubmit)} className="ModuleConfiguratorForm">
          <div className="row ml-0">
            <div className="col-lg-4">
              <NumberEditor label="Big number" fieldName="aBigNumber" formHook={formHook}></NumberEditor>
            </div>
            <div className="col-lg-4">
              <FormattedNumberEditor
                required
                tooltipId={nameof<MapTooltip>("Byggnadsdata_kommun")}
                label="Percentage"
                fieldName="aPercentage"
                formHook={formHook}
                isPercentage={true}
              ></FormattedNumberEditor>
            </div>
          </div>
          <div className="row ml-0">
            <div className="col-lg-8"></div>
            <div className="col-lg-4">
              <Button type="submit">Submit</Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Test;
